export default "__VITE_ASSET__BvcN53GV__"